// extracted by mini-css-extract-plugin
export default {"name":"ClientCell_name__O87Xp","wrapper":"ClientCell_wrapper__CknMk"};